import { useLocation } from 'react-router-dom';

export const useIsAdminModule = () => {
  const { pathname } = useLocation();

  const isAdmin = pathname.split('/')[1] === 'admin';
  return isAdmin;
};
